import { replaceAll } from 'helpers/replaceAll';

const createNumberAriaLabel = (number: number | string) => {
    return replaceAll(number.toString(), ' ', '').split('').join('-');
};

/**
 * Processes HTML content to make numbers screen-reader friendly
 * by adding aria-label attributes with digit-by-digit pronunciation
 */
const processHtmlForAccessibility = (htmlContent: string): string => {
    // Regular expression to match numbers (including those with spaces, dots, commas)
    const numberRegex = /(\d+(?:[\s.,]\d+)*)/g;

    return htmlContent.replace(numberRegex, (match) => {
        const cleanNumber = replaceAll(match, /[\s.,]/g, '');
        const ariaLabel = createNumberAriaLabel(cleanNumber);

        return `<span aria-label="${ariaLabel}">${match}</span>`;
    });
};

export { createNumberAriaLabel, processHtmlForAccessibility };
